import styled from '@emotion/styled';
import { Checkbox } from 'common/components/antd/Checkbox/Checkbox';

export const SCheckboxGroup = styled(Checkbox.Group)`
  display: flex;
  flex-direction: column;
`;
